module.exports = __webpack_public_path__ + "static/media/85x11no3.08bc6d34.jpg";